// @ts-expect-error legacy-hubspot-bender-context is a virtual, undeclared module
import { bender } from 'legacy-hubspot-bender-context';
const {
  staticDomainPrefix
} = bender;
/**
 * A utility function to get the URL of a published pictogram.
 * @param name - The name of the pictogram to get the URL for.
 * @param extension - The extension of the pictogram to get the URL for. Defaults to `.svg`.
 * @returns The URL of the published pictogram with the given name and extension.
 */
export const getImageUrl = (name, extension = '.svg') => {
  return `${staticDomainPrefix}/trellis-assets/static-1.2264/js/pictograms/assets/${encodeURIComponent(name)}${encodeURIComponent(extension)}`;
};